import React from "react";

export default function AuthContextPanel({
    label = "Secure sign-in",
    title,
    items = [],
    helper,
}) {
    const visibleItems = items.filter((item) => item?.value);

    return (
        <section className="border-y border-lightBorder py-4" aria-label={title || label}>
            <div className="border-l-2 border-primary pl-4">
                <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">
                    {label}
                </p>
                {title ? (
                    <h2 className="mt-1 text-base font-semibold leading-6 text-foreground">
                        {title}
                    </h2>
                ) : null}
            </div>

            {visibleItems.length ? (
                <dl className="mt-4 grid gap-3 sm:grid-cols-2">
                    {visibleItems.map((item) => (
                        <div key={item.label} className="min-w-0">
                            <dt className="text-xs font-medium uppercase tracking-[0.12em] text-subText">
                                {item.label}
                            </dt>
                            <dd className="mt-1 break-words text-sm font-semibold text-foreground">
                                {item.value}
                            </dd>
                        </div>
                    ))}
                </dl>
            ) : null}

            {helper ? (
                <p className="mt-4 text-sm leading-6 text-secondary">
                    {helper}
                </p>
            ) : null}
        </section>
    );
}
